/**
 * PageTutorial — thin wrapper around CalculatorTutorial so we can call the
 * same widget "PageTutorial" everywhere (calculators, lessons, community,
 * directory, AI chat, video library, store, recipes, portal, dashboard…).
 *
 * Reads its config from src/config/tutorials.js so copy lives in one place.
 *
 * Usage:
 *   <PageTutorial id="learning" />
 *   <PageTutorial id="ai_chat" />
 *
 * Optionally override any field:
 *   <PageTutorial id="learning" title="Getting started" />
 */
import React from 'react';
import CalculatorTutorial from './CalculatorTutorial';
import { TUTORIALS } from '../config/tutorials';

const PageTutorial = ({ id, ...overrides }) => {
  const cfg = TUTORIALS[id];
  if (!cfg) return null;
  return (
    <CalculatorTutorial
      storageKey={cfg.storageKey}
      title={overrides.title || cfg.title}
      reopenLabel={overrides.reopenLabel || cfg.reopenLabel || 'Show tour'}
      steps={overrides.steps || cfg.steps}
    />
  );
};

export default PageTutorial;
